import { render, staticRenderFns } from "./zan.vue?vue&type=template&id=43b7b9f4&scoped=true&"
import script from "./zan.vue?vue&type=script&lang=js&"
export * from "./zan.vue?vue&type=script&lang=js&"
import style0 from "./zan.vue?vue&type=style&index=0&id=43b7b9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b7b9f4",
  null
  
)

export default component.exports